export default __webpack_public_path__ + "static/media/loginSvgAprobank.8f13cd71.svg";